/* eslint-disable no-useless-concat */
import ENVIRONMENT from "../../../../config/environment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { Card, Input } from "../../../../_metronic/_partials/controls";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import "react-phone-input-2/lib/style.css";
import "react-phone-number-input/style.css";
import IconEye from "../../../../assets/img/eye.svg";
import { i18n } from "../../private/languageSelector";
import IconView from "../../../../assets/img/IconCopy.svg";
import IconDownload from "../../../../assets/img/IconPdf.svg";
import IconClose from "../../../../assets/img/closeIconInvoice.svg";
import IconXml from "../../../../assets/img/company/xmlIcon.svg";

import { AsYouType } from "libphonenumber-js/max";
import { cloneDeep } from "lodash";

let asYouType = new AsYouType();

Yup.addMethod(Yup.mixed, "validatePhoneNumber", function(msg) {
  return this.test({
    name: "validatePhoneNumber",
    message: msg,
    test: (value) => {
      if (value) {
        asYouType.reset();
        asYouType.input(value);
        return asYouType.getNumber().isValid();
      } else {
        return true;
      }
    },
  });
});
// Validation schema
const pdfInvoiceDialog = Yup.object().shape({
  email: Yup.string()
    .email(i18n("Validation.WrongEmailFormat"))
    .matches(
      // eslint-disable-next-line
      /^\w+[\w-\.]*\@\w+((-\w+)|(\w*))\.[a-z]{2,3}$/,
      "Must contain e.g (example._-@example.com)",
    ),
  mobile: Yup.string().validatePhoneNumber(i18n("Validation.INVALID_PHONE")),
});
const initPDFInvoiceDialog = {
  email: "",
  mobile: "",
  // sendViaSMS: "",
  // smsMessage: "",
  // emailMessage: "",
  // sendViaEmail: true,
  // arabicLang: false,
  // englishLang: false,
  invoiceUrl: `${ENVIRONMENT.appUrl}view/invoiceHtml/`,
  posInvoiceUrl: `${ENVIRONMENT.appUrl}posInvoice/`,
};

function SendPdfInvoiceDialog({ id, secondaryAction, sendPdfInvoiceDialog, setSendPdfInvoiceDialog }) {
  const dispatch = useDispatch();

  const { invoice } = useSelector((state) => ({
    invoice: state?.invoices.invoiceForEdit,
  }));
  // eslint-disable-next-line
  const [showSms, setShowSms] = useState(false);
  // eslint-disable-next-line
  const [showEmail, setShowEmail] = useState(false);
  const [englishLanguage, setEnglishLanguage] = useState(false);
  // eslint-disable-next-line
  const [arabicLanguage, setArabicLanguage] = useState(false);
  // eslint-disable-next-line
  const [emailMessage, setEmailMessage] = useState("");

  useEffect(() => {
    setEnglishLanguage(invoice?.selectedInvoiceLanguage === "en" ? true : false);
    setArabicLanguage(invoice?.selectedInvoiceLanguage === "ar" ? true : false);
  }, [invoice]);

  let resetFromState;

  let copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const { language } = useSelector((state) => state.auth);

  const handleChangeInvoiceLanguage = async () => {
    let invoiceToUpdate = cloneDeep({ ...invoice, selectedInvoiceLanguage: englishLanguage && !arabicLanguage ? "ar" : "en" });
    await axios.patch(`api/invoice/${invoice?._id}`, invoiceToUpdate).then((res) => {
      toast.success(res.data.message);
    });
  };
  // let refactoredProds = invoice?.invoiceData?.products?.map((item) => {
  //   return { name: item?.name, quantity: Number(item?.quantity), price: Number(item?.price) };
  // });
  // const invoiceData = {
  //   type: invoice?.invoiceData?.invoiceType || "sale",
  //   invoiceNumber: invoice?.invoiceData?.invoiceNumber || "INV-1001",
  //   issueDate: invoice?.invoiceData?.invoiceDate || "2025-10-02",
  //   seller: {
  //     name: invoice?.invoiceData?.senderInformation?.storeData?.name || "ABC Company",
  //     vatNumber: invoice?.invoiceData?.senderInformation?.storeData?.taxNumber || "1234567890",
  //   },
  //   buyer: {
  //     name: `${invoice?.invoiceData?.receiverInformation?.name?.first} ${invoice?.invoiceData?.receiverInformation?.name?.last}` || "XYZ Client",
  //     vatNumber: invoice?.invoiceData?.receiverInformation?.taxNumber || "9876543210",
  //   },
  //   items: refactoredProds,
  //   total: Number(invoice?.invoiceData?.totalaftertax),
  // };

  const handleDownloadInvoiceXml = () => {
    const xml = invoice?.zatca?.signedXml;
    if (!xml) {
      toast.error("No signed XML available for this invoice");
      return;
    }

    const blob = new Blob([xml], { type: "application/xml;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${invoice?.invoiceData?.invoiceNumber}_${invoice?.zatca?.uuid}.xml`;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    toast.success("XML generated successfully");
    setSendPdfInvoiceDialog(false);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{ initPDFInvoiceDialog }}
        validationSchema={pdfInvoiceDialog}
        onSubmit={(values) => {
          // if (values?.sendViaSMS === true && values?.sendViaEmail === true) {
          //   const smsMessageDetails = {
          //     recipient: "+923364184194",
          //     sender: "+19042951659",
          //     content:
          //       invoice?.invoiceData?.channel === "web"
          //         ? smsMessage + " " + "Your Invoice URL is here " + initPDFInvoiceDialog.invoiceUrl + id
          //         : smsMessage + " " + "Your Invoice URL is here " + initPDFInvoiceDialog.posInvoiceUrl + id,
          //     invoiceLanguage: englishLanguage && !arabicLanguage ? "en" : "ar",
          //   };
          //   const emailMessageDetails = {
          //     recipient: values.email,
          //     subject: "suppot@fatoraty.com",
          //     content:
          //       emailMessage + invoice?.invoiceData?.channel === "web"
          //         ? "Your Invoice URL is here " + initPDFInvoiceDialog.invoiceUrl + id
          //         : "Your Invoice URL is here " + initPDFInvoiceDialog.posInvoiceUrl + id,
          //     invoiceLanguage: englishLanguage && !arabicLanguage ? "en" : "ar",
          //   };
          //   dispatch(
          //     axios
          //       .post("api/message", smsMessageDetails)
          //       .then(
          //         dispatch(
          //           axios
          //             .post("api/email", emailMessageDetails)
          //             .then(
          //               toast.success("Url send Via Email and SMS"),
          //               resetFromState.resetForm(initPDFInvoiceDialog),
          //               setEmailMessage(""),
          //               setSmsMessage("")
          //             )
          //         )
          //       )
          //   );
          // }

          const emailMessageDetails = {
            recipient: values.email,
            subject: "suppot@fatoraty.com",
            content:
              invoice?.invoiceData?.channel === "web" ? `${initPDFInvoiceDialog.invoiceUrl + id}` : `${initPDFInvoiceDialog.posInvoiceUrl + id}`,
            invoiceId: id,
            invoiceLanguage: englishLanguage && !arabicLanguage ? "en" : "ar",
          };

          dispatch(
            axios
              .post("api/email", emailMessageDetails)
              .then(toast.success("Url send Via Email"), resetFromState.resetForm(initPDFInvoiceDialog), setEmailMessage("")),
          );

          // else if (values?.sendViaSMS === true) {
          //   const smsMessageDetails = {
          //     recipient: "+923364184194",
          //     sender: "+19042951659",
          //     content:
          //       invoice?.invoiceData?.channel === "web"
          //         ? smsMessage + " " + "Your Invoice URL is here " + initPDFInvoiceDialog.invoiceUrl + id
          //         : smsMessage + " " + "Your Invoice URL is here " + initPDFInvoiceDialog.posInvoiceUrl + id,
          //     invoiceLanguage: englishLanguage && !arabicLanguage ? "en" : "ar",
          //   };
          //   dispatch(
          //     axios
          //       .post("api/message", smsMessageDetails)
          //       .then(toast.success("Url send Via SMS"), resetFromState.resetForm(initPDFInvoiceDialog), setSmsMessage(""))
          //   );
          // }
        }}
      >
        {({ handleSubmit, values, setValues, setFieldValue, errors, ...rest }) => {
          resetFromState = rest;
          return (
            <>
              <Form className="form form-label-right">
                <Modal
                  className={`${language === "arabic" ? "modal-dialog-arabic modal-drawer" : " modal-drawer"}  my-profile invoice-drawer`}
                  size="lg"
                  show={sendPdfInvoiceDialog}
                  onHide={() => {}}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <div className="bg-white">
                    <div className={`d-flex align-items-center p-4 ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                      <div
                        onClick={() => {
                          setSendPdfInvoiceDialog(false);
                          setShowEmail(false);
                          setShowSms(false);
                        }}
                        className="cursor-pointer"
                      >
                        <img src={IconClose} alt="close" />
                      </div>

                      <Modal.Title className="ml-auto mr-auto custom-text-invoice" style={{ color: "#3f4254" }}>
                        {i18n("INVOICES.ShareInvoice")}
                      </Modal.Title>
                    </div>
                  </div>

                  <Modal.Body className="overlay overlay-block cursor-default" style={{ background: "#F2F2F2" }}>
                    <Card className="rounded mx-1">
                      <div className={`row ${language === "arabic" ? "flex-row-reverse text-right" : "text-left flex-row"}`}>
                        <div className={`col-lg-12 $`}>
                          <p>{i18n("INVOICES.InvoiceLanguage")}</p>
                        </div>
                        <div className={`col-6 d-flex ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                          <Field
                            type="radio"
                            // name="engishLang"
                            value={englishLanguage}
                            checked={englishLanguage}
                            onChange={(e) => {
                              setEnglishLanguage((p) => !p);
                              setArabicLanguage(false);
                              handleChangeInvoiceLanguage();
                            }}
                            style={{ textAlign: language === "arabic" ? "end" : "start" }}
                          />
                          <label className={`${language === "arabic" ? "mr-4" : "ml-4"}`}>{i18n("INVOICES.ENGLISH")}</label>
                        </div>
                        <div className={`col d-flex ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                          <Field
                            type="radio"
                            // name="arabicLang"
                            checked={arabicLanguage}
                            value={arabicLanguage}
                            onChange={(e) => {
                              setArabicLanguage((p) => !p);
                              setEnglishLanguage(false);
                              handleChangeInvoiceLanguage();
                            }}
                            style={{ textAlign: language === "arabic" ? "end" : "start" }}
                          />
                          <label className={`${language === "arabic" ? "mr-4" : "ml-4"}`}>{i18n("INVOICES.ARABIC")}</label>
                        </div>
                      </div>
                    </Card>

                    <Card className="rounded mx-1">
                      <div className={`row ${language === "arabic" ? "flex-row-reverse text-right" : "text-left flex-row"}`}>
                        <div className={`col-lg-12 ${language === "arabic" ? "rtl" : "ltr"}`}>
                          <p>{i18n("INVOICES.InvoiceLink")}</p>
                        </div>
                        <div
                          className="col-7 p-3 d-flex justify-content-center align-items-center"
                          style={{ border: "1px solid rgb(242, 242, 242)" }}
                        >
                          <small>{`${ENVIRONMENT.appUrl}view/invoice/${id}`?.slice(0, 20) + "..."}</small>
                          <div className="cursor-pointer ml-5">
                            <img
                              onClick={() => {
                                // eslint-disable-next-line no-lone-blocks
                                {
                                  invoice?.invoiceData?.channel === "web"
                                    ? copyToClipboard(`${ENVIRONMENT.appUrl}view/invoiceHtml/${id}`)
                                    : copyToClipboard(`${ENVIRONMENT.appUrl}posInvoice/${id}`);
                                }
                                toast.success("Copied to clipboard");
                              }}
                              src={IconView}
                              alt="loading"
                            />
                          </div>
                        </div>
                        <div
                          className={`d-flex justify-content-between align-items-center col ${
                            language === "arabic" ? "flex-row-reverse" : "flex-row"
                          }`}
                        >
                          <div
                            // className="ml-4 cursor-pointer"
                            className="ml-2 cursor-pointer"
                            onClick={() => {
                              // eslint-disable-next-line no-lone-blocks
                              {
                                invoice?.invoiceData?.channel === "web"
                                  ? window.open(`/view/invoiceHtml/${id}`, "_blank")
                                  : window.open(`/posInvoice/${id}`, "_blank");
                              }
                            }}
                          >
                            <img src={IconEye} alt="loading" />
                          </div>
                          <div
                            // className=" mr-3 cursor-pointer"
                            className=" mx-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(`${ENVIRONMENT.appUrl}view/invoice/${id}`, "_blank");
                            }}
                          >
                            <img src={IconDownload} alt="loading" />
                          </div>
                          <div className="cursor-pointer" onClick={handleDownloadInvoiceXml}>
                            <img src={IconXml} alt="loading" />
                          </div>
                        </div>
                      </div>
                    </Card>

                    <Card className="rounded mx-1">
                      <div className={`row ${language === "arabic" ? "flex-row-reverse text-right" : "text-left flex-row"}`}>
                        <div className={`col-lg-12 ${language === "arabic" ? "rtl" : "ltr"}`}>
                          <div className="d-flex justify-content-between align-items-center">
                            <p>{i18n("INVOICES.ShareViaEmail")}</p>{" "}
                            <p>
                              <button
                                type="submit"
                                onClick={() => {
                                  if (errors?.email?.length === 0 || errors?.email === undefined) {
                                    handleSubmit();
                                    secondaryAction();
                                    setSendPdfInvoiceDialog(false);
                                    setShowEmail(false);
                                    setShowSms(false);
                                  }
                                }}
                                className={`border-0 bg-transparent ${language === "arabic" ? "mr-auto" : "ml-auto"}`}
                                style={{
                                  color: values?.email?.length === 0 || !values?.email ? "#2D9CDB80" : "#2D9CDB",
                                  pointerEvents: values?.email?.length === 0 || !values?.email ? "none" : "auto",
                                  fontWeight: 700,
                                  textAlign: language === "arabic" ? "start" : "end",
                                }}
                              >
                                {i18n("INVOICES.SEND")}
                              </button>
                            </p>
                          </div>
                        </div>
                        {/* <div className={`col d-flex ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                          <Field
                            name="sendViaEmail"
                            type="radio"
                            onChange={(e) => {
                              setFieldValue("sendViaEmail", e.target.checked);
                              setShowEmail((p) => !p);
                              setShowSms(false);
                            }}
                            value={showEmail}
                            style={{ textAlign: language === "arabic" ? "end" : "start" }}
                          />
                          <label className={`${language === "arabic" ? "mr-4" : "ml-4"}`}>{i18n("global.Email")}</label>
                        </div>
                        <div className={`col d-flex ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                          <Field
                            name="sendViaSMS"
                            type="radio"
                            onChange={(e) => {
                              setFieldValue("sendViaSMS", e.target.checked);
                              setShowSms((p) => !p);
                              setShowEmail(false);
                            }}
                            value={showSms}
                            style={{ textAlign: language === "arabic" ? "end" : "start" }}
                          />
                          <label className={`${language === "arabic" ? "mr-4" : "ml-4"}`}>{i18n("INVOICES.Sms")}</label>
                        </div> */}

                        <>
                          <>
                            <div className="col-lg-12 mt-4 form-group">
                              <Field
                                style={{
                                  textAlign: language === "arabic" ? "end" : "start",
                                  paddingRight: language === "arabic" && "0px",
                                  right: 0,
                                }}
                                type="email"
                                name="email"
                                label={i18n("global.Email")}
                                isArabicStyle={true}
                                placeholder={i18n("global.Email")}
                                component={Input}
                              />
                            </div>
                            {/* <div className="col-lg-12 mt-4 form-group">
                              {emailMessage?.length > 0 ? (
                                <div
                                  className={`${
                                    document?.activeElement?.name === "emailMessage" ? "store-small-text-active" : "store-small-text-normal"
                                  }`}
                                >
                                  {i18n("global.Message")}
                                </div>
                              ) : (
                                <div className="store-small-text"> {i18n("global.Message")}</div>
                              )}
                              <Field
                                name="emailMessage"
                                label={i18n("global.Message")}
                                placeholder={i18n("global.Message")}
                                component={TextArea}
                                style={{
                                  textAlign: language === "arabic" ? "end" : "start",
                                  paddingRight: language === "arabic" && "0px",
                                  fieldSizing: "content",
                                  height: "auto",
                                }}
                                value={emailMessage}
                                onChange={(e) => {
                                  setEmailMessage(e?.target?.value);
                                }}
                              />
                            </div> */}
                          </>

                          {/* {showEmail || showSms ? (
                            <button
                              type="submit"
                              onClick={() => {
                                handleSubmit();
                                secondaryAction();
                                setSendPdfInvoiceDialog(false);
                                setShowEmail(false);
                                setShowSms(false);
                              }}
                              className={`border-0 bg-transparent ${language === "arabic" ? "mr-auto" : "ml-auto"}`}
                              style={{
                                color:
                                  (showEmail && !showSms && (values?.email?.length === 0 || !values?.email)) ||
                                  (showSms && !showEmail && (values?.mobile?.length === 0 || !values?.mobile || errors?.mobile?.length > 0))
                                    ? "#2D9CDB80"
                                    : "#2D9CDB",
                                pointerEvents:
                                  (showEmail && !showSms && (values?.email?.length === 0 || !values?.email)) ||
                                  (showSms && !showEmail && (values?.mobile?.length === 0 || !values?.mobile || errors?.mobile?.length > 0))
                                    ? "none"
                                    : "auto",
                                fontWeight: 700,
                                textAlign: language === "arabic" ? "start" : "end",
                              }}
                            >
                              {i18n("INVOICES.SEND")}
                            </button>
                          ) : null} */}
                        </>
                      </div>
                    </Card>
                  </Modal.Body>
                </Modal>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
}
export default SendPdfInvoiceDialog;
